import '@babel/polyfill'; //- needed for mocking .finally() with Promisses
import { shallowMount, createLocalVue } from '@vue/test-utils';
import Vuex from 'vuex';
import AddressUpdateSubsModal from './AddressUpdateSubsModal';

const localVue = createLocalVue();
localVue.use(Vuex);

describe('AddressUpdateSubsModal', () => {
  let wrapper;
  let store;
  let updateLastSavedAddressMock;
  let updateShipAddressForSubscriptionsMock;
  let loadCustomerSubsMock;
  let setSavingAddressMock;
  let hideModalMock;

  const lastSavedAddress = { id: 456 };
  const subs = [{ id: 123, products: [{ product_name: 'Name 1' }], has_extra_tube: true }, { id: 234, products: [{ product_name: 'Name 2' }] }];

  beforeEach(() => {
    updateLastSavedAddressMock = jest.fn();
    updateShipAddressForSubscriptionsMock = jest.fn(() => Promise.resolve('Result'));

    loadCustomerSubsMock = jest.fn();
    setSavingAddressMock = jest.fn();
    hideModalMock = jest.fn();

    store = new Vuex.Store({
      modules: {
        addressBook: {
          namespaced: true,
          state: {
            editAddressForm: {},
            selectedAddressId: null,
            lastSavedAddress: lastSavedAddress
          },

          actions: {
            updateLastSavedAddress: updateLastSavedAddressMock,
            updateShipAddressForSubscriptions: updateShipAddressForSubscriptionsMock
          },

          mutations: {
            setSavingAddress: setSavingAddressMock
          }
        },

        subscriptions: {
          namespaced: true,
          state: {
            subsToUpdate: subs
          },
          getters: {
            activeSubscriptions: jest.fn()
          },

          actions: {
            loadCustomerSubs: loadCustomerSubsMock
          }
        },

        modal: {
          namespaced: true,
          actions: {
            hideModal: hideModalMock
          }
        }
      }
    });

    wrapper = shallowMount(AddressUpdateSubsModal, {
      store,
      localVue
    });
  });

  test('general snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('methods', () => {
    describe('onSubmit', () => {
      test('set subIds in payload to array of sub ids', () => {
        wrapper.vm.onSubmit();
        expect(updateShipAddressForSubscriptionsMock).toHaveBeenCalledTimes(1);
        expect(updateShipAddressForSubscriptionsMock.mock.calls[0][1]).toEqual({ subIds: subs.map(sub => sub.id), newAddressId: lastSavedAddress.id });
      });

      test('expected calls', () => {
        return wrapper.vm.onSubmit().then(() => {
          //- setSavingAddress
          expect(setSavingAddressMock).toHaveBeenCalledTimes(2);
          expect(setSavingAddressMock.mock.calls[0][1]).toEqual(true);
          expect(setSavingAddressMock.mock.calls[1][1]).toEqual(false);
          //- updateLastSavedAddress
          expect(updateLastSavedAddressMock).toHaveBeenCalledTimes(1);
          expect(updateLastSavedAddressMock.mock.calls[0][1]).toEqual({});
          //- loadCustomerSubs
          expect(loadCustomerSubsMock).toHaveBeenCalledTimes(1);
          //- hide modal emit
          expect(hideModalMock).toHaveBeenCalledTimes(1);
        });
      });
    });

    describe('cancel', () => {
      test('emit event to close modal', () => {
        wrapper.vm.cancel();
        expect(hideModalMock).toHaveBeenCalledTimes(1);
      });

      test('call updateLastSavedAddress with empty Object', () => {
        wrapper.vm.cancel();
        expect(updateLastSavedAddressMock).toHaveBeenCalledTimes(1);
        expect(updateLastSavedAddressMock.mock.calls[0][1]).toEqual(expect.any(Object));
      });
    });
  });

});
